//import _, { isEmpty, result } from "lodash";
import axios from "axios";
import { forEach, reduce } from "lodash";

class Search {
  // 1. describe and create/initiate our object
  constructor() {
    var _ = require("lodash");

    this.rollDownPredmetyResults = document.querySelector("#box-predmety");
    this.rollDownPredmetySearch = document.querySelector("#toogle-predmety");
    this.liPredmety = document.querySelectorAll(".li-predmety");

    this.rollDownRocnikyResults = document.querySelector("#box-rocniky");
    this.rollDownRocnikySearch = document.querySelector("#toogle-rocniky");
    this.liRocniky = document.querySelectorAll(".li-rocniky");

    this.inputPredmet = document.querySelector(".input-predmet");
    this.inputRocnik = document.querySelector(".input-rocnik");

    this.resultsDiv = document.querySelector(".content-wrapper");

    //--- typing search ---
    this.searchField = document.querySelector(".input-search-type");
    this.previousValue;
    this.isTextIputTOUCHED = false;
    this.typeVar;

    //--- single predmet search ---
    this.predmetyArray;
    this.predmetJustTouchedId;
    this.predmetTouched = false;
    this.predmetTitle;

    //--- single rocnik search ---
    this.rocnikyArray;
    this.rocnikJustTouchedId;
    this.rocnikTouched = false;
    this.rocnikTitle;

    //--- search routes ---
    this.mainRoute = "/wp-json/digital/v1/main";
    this.balikRoute = "/wp-json/digital/v1/balik";
    this.typeRoute = "/wp-json/digital/v1/search?term=";
    this.predmetRoute = "/wp-json/digital/v1/singlePredmet?term=";
    this.rocnikRoute = "/wp-json/digital/v1/singleRocnik?term=";
    this.doubleRoute = "/wp-json/digital/v1/double?pred=";
    this.route;
    this.singlePredmetRoute;
    this.singleRocnikRoute;
    this.bothRoute;
    this.isBalik;
    this.imagesContent;

    //--- default placeholders ---
    this.predmetPlaceholder = "Vyberte predmet";
    this.rocnikPlaceholder = "Vyberte ročník";
    this.typePlaceholder = "Hľadať...";

    //--- reset ---
    this.resetPredmety = document.querySelector(".reset-predmety");
    this.resetRocniky = document.querySelector(".reset-rocniky");
    this.resetType = document.querySelector(".reset-type");

    this.resultsFin;

    this.isSpinnerVisible = false;
    this.typingTimer;
    this.predmetID;
    this.events();

    this.allObjects;

    this.predmetId = "";
    this.rocnikId = "";
    this.typeValue = "";

    this.predmetyArray = new Array();
    this.rocnikyArray = new Array();
    this.typeArray = new Array();

    this.isPredmet;
    this.isRocnik;
    this.isType;

    this.isButtonPredmet = false;
    this.isButtonRocnik = false;
    this.isButtonType = false;

    this.rocnikyArray = new Array();

    this.showNumber = 0;
  }

  // 2. events
  events() {
    this.loadAllObjects();
    try {
      this.rollDownPredmetySearch.addEventListener("click", () =>
        this.showPredmety()
      );

      this.rollDownRocnikySearch.addEventListener("click", () =>
        this.showRocniky()
      );
    } catch {}

    //--- resets start ---
    try {
      this.resetPredmety.addEventListener("click", () => this.resetPredmet());
      this.resetRocniky.addEventListener("click", () => this.resetRocnik());
      this.resetType.addEventListener("click", () => this.resetText());
    } catch {}
    //--- reset end ---

    this.liPredmety.forEach((el) => {
      el.addEventListener("click", (e) => {
        this.predmetId = el.id;
        this.inputPredmet.placeholder = el.getAttribute("name");
        this.inputPredmet.classList.add("selected");
        this.resetPredmety.classList.remove("hidden");
        this.isButtonPredmet = true;
        this.checkResults();
        this.rollDownPredmetyResults.classList.toggle("search-null-height");
      });
    });

    this.liRocniky.forEach((el) => {
      el.addEventListener("click", (e) => {
        this.rocnikId = el.id;
        this.inputRocnik.placeholder = el.getAttribute("name");
        this.inputRocnik.classList.add("selected");
        this.resetRocniky.classList.remove("hidden");
        this.isButtonRocnik = true;
        this.checkResults();
        this.rollDownRocnikyResults.classList.toggle("search-null-height");
      });
    });
    try {
      this.searchField.addEventListener("keyup", () => {
        (this.isTextIputTOUCHED = true), this.typingLogic();
        this.isButtonType = true;
      });
    } catch {}
  }

  // 3. methods (function, action...)
  typingLogic() {
    if (this.searchField.value != this.previousValue) {
      clearTimeout(this.typingTimer);
      // console.log(this.typeValue);

      if (this.searchField.value) {
        this.searchField.classList.add("selected");
        if (!this.isSpinnerVisible) {
          this.resultsDiv.innerHTML =
            '<div class="spinner-wrapper"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></div>';
          this.isSpinnerVisible = true;
        }
        this.typingTimer = setTimeout(this.checkResults.bind(this), 750);
      } else {
        this.isSpinnerVisible = false;
      }
    }
    this.resetType.classList.remove("hidden");
    this.previousValue = this.resultsDiv.value;
  }

  async checkResults() {
    this.nullValues();

    Object.values(this.allObjects).forEach((val) => {
      this.pickingProducts(val);
    });

    if (!this.showNumber) {
      this.nothingFound();
    }
  }

  async loadAllObjects() {
    try {
      this.resultsDiv.innerHTML = "";
    } catch {}
    try {
      if (this.resultsDiv.hasAttribute("id")) {
        this.isBalik = true;
        this.route = raabeDigitalData.root_url + this.balikRoute;
      } else {
        this.isBalik = false;
        this.route = raabeDigitalData.root_url + this.mainRoute;
      }

      const response = await axios.get(this.route);
      this.allObjects = response.data.generalInfo;

      Object.values(this.allObjects).forEach((val) => {
        this.showHtmlResults(val);
      });
    } catch (ex) {
      //console.log(ex);
    }
  }

  showHtmlResults(item) {
    try {
      this.showNumber++;
      //console.log(item.title);
      if (this.isBalik) {
        this.imagesContent = `
        <img class="title-box__img--left" src="${item.pict_1}">
        <img class="title-box__img--right" src="${item.pict_2}">`;
      } else {
        this.imagesContent = `<img class="title-box__img--left" src="${item.pict_1}">`;
      }

      this.resultsDiv.innerHTML += `
          <div class="row-wrapper">
              <a class="book-item" href="${item.permalink}">
                  <div class="title-box">
                      <div class="title-box__images">
                      ${this.imagesContent}
                      </div>
                      <div class="title-box_tile" style="background-image: linear-gradient(${
                        item.color_1
                      }, ${item.color_2});"></div>
              </div>
              
            <div class="book-meta">
                
                <h2 class="book-meta__title">${item.title}</h2>
                <h3 class="book-meta__description">${this.wordsTrim(
                  item.popis,
                  13
                )}...</h3>

                <div class="book-meta__excerpt">${this.wordsTrim(
                  item.hlavny_obsah_stranky,
                  18
                )}...</div>
                </div>
            </a>
        </div>`;
    } catch {}
  }

  showPredmety() {
    this.rollDownPredmetyResults.classList.toggle("search-null-height");
    if (!this.rollDownRocnikyResults.classList.contains("search-null-height")) {
      this.rollDownRocnikyResults.classList.add("search-null-height");
    }
  }

  showRocniky() {
    this.rollDownRocnikyResults.classList.toggle("search-null-height");
    if (
      !this.rollDownPredmetyResults.classList.contains("search-null-height")
    ) {
      this.rollDownPredmetyResults.classList.add("search-null-height");
    }
  }

  wordsTrim(str, no_words) {
    return str.split(" ").splice(0, no_words).join(" ");
  }

  replaceSpecialChars(str) {
    str = str.replace(/[ÀÁÂÃÄÅ]/, "A");
    str = str.replace(/[àáâãäå]/, "a");
    str = str.replace(/[ÈÉÊË]/, "E");
    str = str.replace(/[Ç]/, "C");
    str = str.replace(/[ç]/, "c");
    str = str.replace(/[č]/, "c");
    str = str.replace(/[é]/, "e");
    str = str.replace(/[ú]/, "u");
    str = str.replace(/[š]/, "s");
    str = str.replace(/[,]/, "");
    str = str.replace(/[ó]/, "o");

    // o resto

    return str.replace(/[^a-z0-9]/gi, "");
  }

  //--- RESETy ---
  resetPredmet() {
    this.isButtonPredmet = false;
    this.inputPredmet.placeholder = this.predmetPlaceholder;
    this.inputPredmet.classList.remove("selected");
    this.resetPredmety.classList.add("hidden");
    this.isPredmet = false;
    this.predmetId = "";
    this.showPredmety();
    if (!this.isButtonPredmet && !this.isButtonRocnik && !this.isButtonType) {
      this.loadAllObjects();
    } else {
      this.checkResults();
    }
  }

  resetRocnik() {
    this.isButtonRocnik = false;
    this.inputRocnik.placeholder = this.rocnikPlaceholder;
    this.inputRocnik.classList.remove("selected");
    this.resetRocniky.classList.add("hidden");
    this.isRocnik = false;
    this.rocnikId = "";
    this.showRocniky();
    if (!this.isButtonPredmet && !this.isButtonRocnik && !this.isButtonType) {
      this.loadAllObjects();
    } else {
      this.checkResults();
    }
  }

  resetText() {
    this.isButtonType = false;
    this.isType = false;
    this.searchField.value = "";
    this.resetType.classList.add("hidden");
    if (!this.isButtonPredmet && !this.isButtonRocnik && !this.isButtonType) {
      this.loadAllObjects();
    } else {
      this.checkResults();
    }
  }

  nothingFound() {
    this.resultsDiv.innerHTML = `
    <h1 style="text-align: center; width: 100%">Žiadne výsledky.</h1>
    <p style="text-align: center; width: 100%">
    Skúste upraviť filer.</p>`;
  }

  compareType(val) {
    let lowValTitle = val.title.toLowerCase();
    lowValTitle = this.replaceSpecialChars(lowValTitle);

    let typeValuePure = this.typeValue.toLowerCase();
    typeValuePure = this.replaceSpecialChars(typeValuePure);

    if (lowValTitle.includes(typeValuePure)) {
      this.isType = true;
    } else {
      this.isType = false;
    }
  }

  shooting(val) {
    //--- if contain ---
    if (this.isButtonPredmet && !this.isButtonRocnik && !this.isButtonType) {
      if (this.isPredmet) {
        this.showHtmlResults(val);
      }
    }

    if (!this.isButtonPredmet && this.isButtonRocnik && !this.isButtonType) {
      if (this.isRocnik) {
        this.showHtmlResults(val);
      }
    }

    if (this.isButtonPredmet && this.isButtonRocnik && !this.isButtonType) {
      if (this.isRocnik && this.isPredmet) {
        this.showHtmlResults(val);
      }
    }

    if (this.isButtonPredmet && !this.isButtonRocnik && this.isButtonType) {
      if (this.isPredmet && this.isType) {
        this.showHtmlResults(val);
      }
    }

    if (!this.isButtonPredmet && this.isButtonRocnik && this.isButtonType) {
      if (this.isRocnik && this.isType) {
        this.showHtmlResults(val);
      }
    }

    if (this.isButtonPredmet && this.isButtonRocnik && this.isButtonType) {
      if (this.isPredmet && this.isRocnik && this.isType) {
        this.showHtmlResults(val);
      }
    }

    if (!this.isButtonPredmet && !this.isButtonRocnik && this.isButtonType) {
      if (this.isType) {
        this.showHtmlResults(val);
      }
    }
  }

  pickingProducts(val) {
    //--- predmet
    if (this.predmetId && !this.rocnikId && !this.typeValue) {
      Object.values(val.id_predmet).forEach((predmet) => {
        if (this.predmetId == predmet.ID) {
          this.isPredmet = true;
          this.showHtmlResults(val);
        } else {
          this.isPredmet = false;
        }
      });
    }

    //--- rocnik
    if (this.rocnikId && !this.predmetId && !this.typeValue) {
      Object.values(val.id_rocnik).forEach((rocnik) => {
        if (this.rocnikId == rocnik.ID) {
          this.isRocnik = true;
          this.showHtmlResults(val);
        } else {
          this.isRocnik = false;
        }
      });
    }

    //--- predmet a rocnik
    if (this.predmetId && this.rocnikId && !this.typeValue) {
      this.isPredmet = false;
      this.isRocnik = false;
      Object.values(val.id_predmet).forEach((predmet) => {
        if (this.predmetId == predmet.ID) {
          this.isPredmet = true;
        }
      });

      Object.values(val.id_rocnik).forEach((rocnik) => {
        if (this.rocnikId == rocnik.ID) {
          this.isRocnik = true;
        }
      });

      if (this.isPredmet && this.isRocnik) {
        this.showHtmlResults(val);
        this.isPredmet = false;
        this.isRocnik = false;
      }
    }

    //--- predmet a text
    if (this.predmetId && this.typeValue && !this.rocnikId) {
      this.isPredmet = false;
      this.isType = false;
      Object.values(val.id_predmet).forEach((predmet) => {
        if (this.predmetId == predmet.ID) {
          this.isPredmet = true;
        } else {
          this.isPredmet = false;
        }
      });
      this.compareType(val);

      if (this.isPredmet && this.isType) {
        this.showHtmlResults(val);
        this.isPredmet = false;
        this.isType = false;
      }
    }

    //--- rocnik a text
    if (this.rocnikId && this.typeValue && !this.predmetId) {
      this.isRocnik = false;
      this.isType = false;
      Object.values(val.id_rocnik).forEach((rocnik) => {
        if (this.rocnikId == rocnik.ID) {
          this.isRocnik = true;
        }
      });

      this.compareType(val);

      if (this.isRocnik && this.isType) {
        this.showHtmlResults(val);
      }
    }

    //--- predmet, rocnik, text
    if (this.predmetId && this.rocnikId && this.typeValue) {
      this.isPredmet = false;
      this.isRocnik = false;
      this.isType = false;
      Object.values(val.id_predmet).forEach((predmet) => {
        if (this.predmetId == predmet.ID) {
          this.isPredmet = true;
        }
      });

      Object.values(val.id_rocnik).forEach((rocnik) => {
        if (this.rocnikId == rocnik.ID) {
          this.isRocnik = true;
        }
      });

      this.compareType(val);

      if (this.isPredmet && this.isRocnik && this.isType) {
        this.showHtmlResults(val);
      }
    }

    //--- text
    if (this.typeValue && !this.predmetId && !this.rocnikId) {
      this.isType = false;
      this.compareType(val);

      if (this.isType) {
        this.showHtmlResults(val);
      }
    }
  }

  nullValues() {
    this.showNumber = 0;
    this.typeValue = this.searchField.value;
    this.resultsDiv.innerHTML = "";
    this.isPredmet = false;
    this.isRocnik = false;
    this.isType = false;
    this.rocnikyArra = [];
  }
}

export default Search;
